namespace Solovis.UI {

    export interface ControlHostOptions {
        container?: JQuery | HTMLElement;
        parentControl?: Solovis.UI.BaseControl;
        routeMap?: Solovis.UI.ControlRouteMap;
    }

    export class ControlHost {

        public container: JQuery;
        public parentControl: any;
        public routeMap: Solovis.UI.ControlRouteMap;
        public currentControl: any;

        public _loadingIndicator: JQuery;
        public hashUrlHandlerOptions: any;
        public waitingOnDestroy: Solovis.UI.BaseControl;
        public waitingOnInit: Solovis.UI.BaseControl;
        public waitingToRender: Solovis.UI.BaseControl;


        constructor(options: ControlHostOptions) {
            this.container = options.container ? $(options.container) : null;
            this.parentControl = options.parentControl ? options.parentControl : null;

            this.routeMap = options.routeMap ? options.routeMap : null;

            this.currentControl = null;

            if (this.container) {
                this.container.addClass("control-host");
                (this.container.get(0) as any).__controlHost = this;
            }
        }        

        public setContainer(container) {
            var containerElement;
            if (this.container) {
                containerElement = this.container.get(0);
                if (containerElement) {
                    delete containerElement.__controlHost;
                }
            }

            this.container = container ? $(container) : null;

            if (this.container) {
                this.container.addClass("control-host");
                containerElement = this.container.get(0);
                if (containerElement) {
                    containerElement.__controlHost = this;
                }
            }
        }

        public showWaitingStatus(): void {
            if (this.container) {
                if (!this._loadingIndicator) {
                    this._loadingIndicator = $("<div>")
                        .addClass("progress-indeterminate");

                    this._loadingIndicator
                        .append(
                        $("<div>")
                            .addClass("waitingbar waitingblock_1"))
                        .append(
                        $("<div>")
                            .addClass("waitingbar waitingblock_2"))
                        .append(
                        $("<div>")
                            .addClass("waitingbar waitingblock_3"))
                        .append(
                        $("<div>")
                            .addClass("waitingbar waitingblock_4"))
                        .append(
                        $("<div>")
                            .addClass("waitingbar waitingblock_5"));

                    this._loadingIndicator.appendTo(this.container);
                }
            }
        }


        public hideWaitingStatus() {
            if (this.container) {
                if (this._loadingIndicator) {
                    this._loadingIndicator.remove();
                    delete this._loadingIndicator;
                }
            }
        }

        public _createControlContainer() {
            if (this.container) {
                var controlContainer = $("<div>").appendTo(this.container);
                if (this.container.get(0).style.height == "100%") {
                    // We will copy down height 100% to the control container to preserve full height scaling.
                    controlContainer.get(0).style.height = "100%";
                }
                return controlContainer;
            }
            else {
                throw "Container not set on ControlHost.";
            }
        }

        public registerAsHashUrlHandler(options) {
            var self = this;

            this.hashUrlHandlerOptions = options;

            $(window).bind("hashchange", function () {
                self.processHashUrlChange(false);
            });
        }

        public processHashUrlChange(isInitialLoad) {
            var hash = window.location.hash.slice(1);
            if (hash == null || hash == "" || hash == "/") {
                hash = this.hashUrlHandlerOptions.defaultRoutePath;
            }

            var route = new Solovis.UI.ControlRoute({ route: hash });

            if (!this.processRoute(route)) {
                // Unrecognized route, so redirect to main portal.
                window.location.hash = "#";
            }
        }

        /**
         * processRoute will update the current control based on route and controlType.
         * If the current control is a controlType, then reroute will be called if reroute is defined on the control.
         * @param route
         * @param controlType
         */
        public processRoute(route: Solovis.UI.ControlRoute, controlType?) {         
            if (typeof controlType == "undefined") {
                if (this.routeMap) {
                    var matchedRouteData = this.routeMap.matchRoute(route);
                    if (matchedRouteData && matchedRouteData.controlType) {
                        var controlRoute = route.getSubRoute(matchedRouteData.route.getRoutePartCount());
                        return this.processRoute(controlRoute, matchedRouteData.controlType);
                    }
                    else {
                        return false;
                    }
                }
                else {
                    throw "No route map or control type specified.";
                }
            }

            if (this.isCurrentControlType(controlType)) {
                if (this.currentControl.reroute) {
                    if (this.currentControl.reroute(route)) {
                        return true;
                    }
                }
            }

            var newControlOptions: any = { controlHost: this, route: route };

            if (typeof controlType == "string") {
                var controlTypeStr = controlType;
                controlType = Solovis.resolveObject(controlTypeStr, window);

                if (!controlType) {
                    controlType = Solovis.UI.DynamicLoadPlaceholderControl;
                    newControlOptions = {
                        controlTypeName: controlTypeStr,
                        newControlOptions: newControlOptions
                    };
                }
            }

            var newControl = new controlType(newControlOptions);
            this.setCurrentControl(newControl);

            return true;
        }

        /**
         * unifiedSearchHandler will see if the current control can handle a unified search request.
         * @param item
         */
        public unifiedSearchHandler(item: any): boolean { 
            if (this.currentControl) {
                if (this.currentControl.unifiedSearchHandler) {
                    if (this.currentControl.unifiedSearchHandler(item)) {
                        return true;
                    }
                }
            }

            return false;
        }

        public setCurrentControl(newControl: Solovis.UI.BaseControl): void {
            var self = this;

            if (newControl && newControl.state != Solovis.UI.BaseControl.ControlState.uninitialized) {
                throw "ControlHost.setCurrentControl expects controls in an uninitialized state.";
            }

            if (this.currentControl) {
                this.waitingOnDestroy = this.currentControl;
                $(this.currentControl).one(
                    "destroyComplete",
                    function () {
                        if (this === self.waitingOnDestroy) {
                            self.waitingOnDestroy = null;

                            // Only show waiting status if we are still waiting on init.
                            if (self.waitingOnInit) {
                                self.showWaitingStatus();
                            }

                            if (self.waitingToRender) {
                                // Process the delayed render now.
                                self.waitingToRender._invokeRender();
                                self.waitingToRender = null;
                            }
                        }
                    });
                this.currentControl._invokeDestroy();
            }
            else {
                // We don't have to wait for destroy operation, so immediately show waiting status if we are going to be showing a new control.
                if (newControl) {
                    this.showWaitingStatus();
                }
            }

            this.waitingOnInit = newControl;

            // If we set a new currentControl before the prior one finishes initializing, we don't
            // want to render the old one.

            this.waitingToRender = null;

            if (newControl) {
                $(newControl).one(
                    "initComplete",
                    function () {
                        if (this === self.waitingOnInit) {
                            self.waitingOnInit = null;

                            self.hideWaitingStatus();

                            // Tell the control to render itself since it has loaded enough data to do so;
                            // however, if we are waiting for previous control to destroy itself, we must wait
                            // and do the render after destroy completes.
                            if (!self.waitingOnDestroy) {
                                this._invokeRender();
                            }
                            else {
                                self.waitingToRender = this;
                            }
                        }
                    });

                newControl.controlHost = this;
                newControl._invokeInit();
            }

            this.currentControl = newControl;
        }

        public isCurrentControlType(controlType): boolean {
            if (!this.currentControl || !controlType)
                return false;

            var controlTypeObject;
            if (typeof controlType == "string")
                controlTypeObject = Solovis.resolveObject(controlType, window);
            else
                controlTypeObject = controlType;

            if (controlTypeObject && this.currentControl && this.currentControl instanceof controlTypeObject) {
                return true;
            }

            return false;
        }


        public static Transitions = {
            Default: null,

            None: {
                beforeRender: function (control) {
                },

                afterRender: function (control) {
                },

                beforeDestroy: function (control, callback) {
                    if (callback) {
                        callback();
                    }
                }
            },

            Fade: {
                beforeRender: function (control) {
                    if (control.container)
                        control.container.css("display", "none");
                },

                afterRender: function (control) {
                    if (control.container)
                        control.container.fadeIn({ duration: 400 });
                },

                beforeDestroy: function (control, callback) {
                    if (control.container) {
                        control.container.fadeOut({
                            duration: 400,
                            always: function () {
                                if (callback) {
                                    callback();
                                }
                            }
                        });
                    }
                    else {
                        if (callback) {
                            callback();
                        }
                    }
                }
            },

            SlideUpDown: {
                beforeRender: function (control) {
                    if (control.container)
                        control.container.css("display", "none");
                },

                afterRender: function (control) {
                    if (control.container)
                        control.container.slideDown({ duration: 400 });
                },

                beforeDestroy: function (control, callback) {
                    if (control.container) {
                        control.container.slideUp({
                            duration: 400,
                            always: function () {
                                if (callback) {
                                    callback();
                                }
                            }
                        });
                    }
                    else {
                        if (callback) {
                            callback();
                        }
                    }
                }
            }
        }
    }        

}